import * as Redux from 'redux';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { SignupActionTypes, SignupResponse } from './signup.types';
import * as SIGNUP_ACTION_TYPES from './signup.constants';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const checkEmailAvailability: Redux.ActionCreator<
  ReduxPromiseAction<
    SignupActionTypes, SimpleResponse<SignupResponse>
  >
> = (email: string): ReduxPromiseAction<SignupActionTypes, SimpleResponse<SignupResponse>> => ({
  type: SIGNUP_ACTION_TYPES.VALIDATE_EMAIL,
  payload: callApi(
    process.env.REACT_APP_API + '/account/input/validation',
    false,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({email})
    }
  )
});

export const createAccount: Redux.ActionCreator<
  ReduxPromiseAction<
    SignupActionTypes, SimpleResponse<SignupResponse>
  >
> = (firstName: string, lastName: string, email: string, password: string, phone: string): ReduxPromiseAction<
  SignupActionTypes, SimpleResponse<SignupResponse>
> => ({
  type: SIGNUP_ACTION_TYPES.CREATE_ACCOUNT,
  payload: callApi(
    process.env.REACT_APP_API + '/account/client',
    true,
    {
      method: 'POST',
      headers: {
        'Authorization': pickAuthOrImpersonationToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({firstName, lastName, email, password, phone})
    }
  ),
  meta: {email: email}
});



// WEBPACK FOOTER //
// ./src/admin/signup.actions.tsx